<template>
  <div class="sp_upgradeCase">
    <el-dialog title="Escalate"
               :visible="escslateMsg.show"
               width="40%"
               class="sp_upgrade-body"
               :before-close="handleClose"
               :append-to-body='true'>
      <el-row class="sp_upgrade-form">
        <el-form :model="upgradeCaseForm"
                 ref="upgradeCaseForm"
                 :rules="upgradeCaseRules">
          <el-col class="form-col"
                  :span="24">
            <el-form-item label="Escalation Reason:"
                          prop="upgradeReason">
              <el-radio-group v-model="upgradeCaseForm.upgradeReason"
                              style="padding:0 10px;">
                <el-radio style="width:100%; padding:6px 0;"
                          v-for="val in upgradeReasonData"
                          :key="val.label"
                          :label="val.label">{{val.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col class="form-col"
                  :span="24">
            <el-form-item label="Escalation Reason:"
                          prop="detailReason">
              <el-input style="padding:0 10px;"
                        type="textarea"
                        v-model="upgradeCaseForm.detailReason"
                        :autosize="{minRows: 6, maxRows: 8}"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="upgradeCase('upgradeCaseForm')"
                   :loading="submitLoading">Submit</el-button>
        <el-button @click="handleClose">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { upgradeCaseApi } from '@/api/case.js'
export default {
  name: "upgradeCase",
  props: {
    escslateMsg: {
      type: Object,
      required: true,
      default: () => { },
    }
  },
  data () {
    var checkdetailReason = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('Please input a detailed reason.')))
      }
      setTimeout(() => {
        if (value.length < 1000) {
          callback()
        } else {
          callback(new Error(this.$t('Detail Reason cannot exceed 1000 characters.')))
        }
      }, 200)
    }
    return {
      upgradeCaseForm: {
        upgradeReason: '',
        detailReason: "",
      },
      upgradeCaseRules: {
        upgradeReason: [
          { required: true, message: 'Please select Upgrade Reason.', trigger: 'change' },
        ],
        detailReason: [
          { required: true, validator: checkdetailReason, trigger: "blur" },
        ],
      },
      upgradeReasonData: [
        { label: 1, name: 'Business effected.', },
        { label: 2, name: 'No solution.', },
        { label: 3, name: 'Bad attitude.', },
        { label: 4, name: 'Difficulty/unable to coordinate with the third-party vendor.', },
        { label: 5, name: 'Unsatisfied with the provided resolution/suggestion/action.', },
        { label: 6, name: 'Technical ability needs to be improved.', },
        { label: 7, name: 'New important feature request for resolution.', },
        { label: 8, name: 'Others.', },
      ],
      submitLoading: false,
    }
  },

  methods: {
    handleClose () {
      this.$emit('escslateChildMsg', { isSave: false, close: false })
    },

    //升级工单
    upgradeCase (upgradeCaseForm) {
      this.$refs[upgradeCaseForm].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          let params = JSON.parse(JSON.stringify(this.upgradeCaseForm))
          params.caseId = this.escslateMsg.row.caseId;
          upgradeCaseApi(params).then(res => {
            this.submitLoading = false;
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: res.msg
              })
              this.$emit('escslateChildMsg', { isSave: true, close: false })
            } else if (res.code == 500) {
              this.$message({
                message: 'The case escalation failed, please escalate again after 2 minutes.',
                type: "error",
              });
            }
          }).catch(() => {
            this.submitLoading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sp_upgrade-body {
  .sp_upgrade-form {
    padding: 16px 10px;
    .form-col {
      /deep/.el-form-item__label {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #545c66;
        margin-bottom: 4px;
      }

      /deep/.el-radio__label {
        font-size: 14px;
        color: #333940;
      }
    }
  }
}
/deep/.el-dialog__body {
  padding: 0 20px !important;
}
</style>